import { ExtendedTheme, Heading, Link, TextBlock } from 'neon-design-system';
import { Paper } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { config } from '../../config';
import { LinkText } from '../LinkText/LinkText';

interface Props {
  additionalDetails?: boolean;
}

const useStyles = makeStyles((theme: ExtendedTheme) =>
  createStyles({
    paper: {
      padding: theme.spacing(4),
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2)
    },
    bold: {
      fontWeight: 700
    },
    emailUs: {
      gap: theme.spacing(0.5)
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'column'
    },
    location: {
      gap: theme.spacing(1)
    }
  })
);

export const SupportContactCard = ({ additionalDetails = false }: Props) => {
  const classes = useStyles();
  return (
    <Paper className={classes.paper}>
      <Heading styleName="headline1" color="white">
        If you need further assistance
      </Heading>
      <div className={[classes.wrapper, classes.emailUs].join(' ')}>
        <TextBlock styleName="body" className={classes.bold}>
          Email us at
        </TextBlock>
        <Link ignoreRouter to={`mailto:${config.contactSupportEmail}`}>
          <LinkText>neon@marex.com</LinkText>
        </Link>
      </div>
      {additionalDetails && (
        <div className={[classes.wrapper, classes.location].join(' ')}>
          <Heading styleName="headline1">Chicago Office</Heading>
          <TextBlock styleName="body">
            Marex
            <br /> 222 W Adams Street
            <br /> Suite 450
            <br /> Chicago, IL 60606
            <br /> +1 312 795 7930
            <br />
            <Link ignoreRouter to="https://marex.com" target="_blank">
              <LinkText>www.marex.com</LinkText>
            </Link>
          </TextBlock>
        </div>
      )}
    </Paper>
  );
};
